import { Grid, CardContent, Typography } from '@mui/material';

import InfoValueRow from '@shared/components/InfoValueRow';
import PaymentDetails from '@shared/components/PaymentDetails';

const BookingPriceDetails = ({
  details,
  showTitle,
  isInUSD,
  cardData,
  currencyValue,
  chargesMessage,
}) => {
  const rows = [
    {
      label: 'Tarifa',
      amount: details?.total_with_out_taxes,
      show: Number(details?.total_with_out_taxes) !== Number(details?.total),
    },
    { label: 'Impuesto PAIS', amount: details?.rates?.impuestoO5 },
    { label: 'Imp. ARCA', amount: details?.rates?.impuestoQ1 },
    { label: 'RG 5463', amount: details?.rates?.taxQ1 },
    { label: 'RG 5450', amount: details?.rates?.RG5450 },
    { label: 'RG 5430', amount: details?.rates?.RG5430 },
    { label: 'RG 5272', amount: details?.rates?.impuestoRG7252 },
    {
      label: 'Gastos Adm',
      amount: details?.charges,
      show: details?.charges > 0,
    },
  ];

  return (
    <CardContent style={{ padding: 0 }}>
      {showTitle && (
        <Grid item xs={12}>
          <Typography
            sx={{
              width: '100%',
              color: '#000',
              fontWeight: 700,
              fontSize: { xs: '18px', md: '20px' },
              pb: 2,
              lineHeight: 1,
            }}
          >
            Detalle de tu pago
          </Typography>
        </Grid>
      )}

      <Grid container direction="column">
        {rows
          ?.filter(x => x.show !== false)
          .map((row, index) => (
            <InfoValueRow
              key={`${row.label}-${+index}`}
              label={row.label}
              value={row.amount}
              isPrice
              isInUSD={isInUSD}
            />
          ))}

        <PaymentDetails
          cardData={cardData}
          total={details?.total}
          isInUSD={isInUSD}
          currencyValue={currencyValue}
          chargesMessage={chargesMessage}
          productType="hotel"
        />
      </Grid>
    </CardContent>
  );
};

export default BookingPriceDetails;
